import * as React from 'react';
import {useContext} from 'react';
import {ServiceContext} from '../../../../components/Services';
import YesNo from '../../../../components/YesNo';
import ManagementTable from '../../components/ManagementTable';
import BatteryTypeForm from '../../forms/BatteryTypeForm';

const BatteryTypes = () => {
  const services = useContext(ServiceContext);
  return (
    <ManagementTable
      title="Battery Types"
      addTitle="Add New Type"
      editTitle="Edit Type"
      columns={[
        {title: 'Name', field: 'name'},
        {title: 'Scorpion Reference', field: 'scorpion_reference'},
        {title: 'Default?', field: 'is_default', render: data => <YesNo value={data.is_default}/>},
      ]}
      loadData={async (query) => services.batteryType.getTableTypes(query)}
      renderForm={(props, type, onSaved) => (
        <BatteryTypeForm
          {...props}
          type={type ?? {}}
          onSaved={onSaved}
        />
      )}
    />
  );
};

export default BatteryTypes;
